module.exports = __webpack_public_path__ + "media/images/flags/my-5be1f9df879b4689d72760e9f4bf0dfd.svg";